export default "__VITE_ASSET__5094780a__"